import { useMemo } from 'react'
import { Link, useHistory } from 'react-router-dom'

import { AddAccountPaths, Paths } from '../../config/routes'
import { useSignOut } from '../../hooks/use-sign-out'
import { ellipsisString } from '../../lib/helpers'
import Logo from '../../masalogo.png'
import { AddMetamask } from '../add-metamask'
import { Dropdown } from '../dropdown'
import { ChevronDown } from '../icons/icon-chevron-down'

export interface HeaderProps {
    /** User names */
    firstName?: string
    lastName?: string
    /** Wallet connected */
    connectedMetamask: boolean
}

const getApplicationVersion = () => {
    const { version } = require('../../../package.json')
    return `v${version}`
}

/**
 * Component to display the information of a certain account
 */
export function Header({
    firstName,
    lastName,
    connectedMetamask = false,
}: HeaderProps) {
    const signOut = useSignOut()
    const history = useHistory()

    const dropdownOptions = useMemo(
        () => [
            [
                {
                    label: 'Dashboard',
                    onClick: () => history.push(Paths.DASHBOARD),
                },
                {
                    label: 'Add a new account',
                    onClick: () =>
                        history.push(AddAccountPaths.ADD_BANK_ACCOUNT),
                },
                {
                    label: 'Settings',
                    onClick: () => history.push(Paths.UPDATE_PROFILE),
                },
            ],
            [
                {
                    label: 'Sign out',
                    onClick: signOut,
                },
            ],
        ],
        [history, signOut],
    )

    return (
        <div
            className={
                'flex  bg-current justify-between  bg-black items-center px-4 pr-0 h-20 flex-row sm:px-16 xs:px-8 sm:justify-between'
            }>
            <Link to={Paths.DASHBOARD}>
                <h2
                    className={
                        'flex-grow flex flex-row text-2xl mt-4 font-extralight'
                    }>
                    <img src={Logo} alt={'Masa Logo'} className='h-4 w-16' />
                    <span className='ml-2 text-xs'>
                        {getApplicationVersion()}
                    </span>
                </h2>
            </Link>
            <div className={'flex flex-row items-center'}>
                <div className={'text-right mr-4 mt-2'}>
                    <div className='text-base not-italic font-light leading-4 tracking-wide text-right text-white'>
                        {`${ellipsisString(firstName, 10) ?? ''} ${
                            ellipsisString(lastName, 10) ?? ''
                        }`}
                    </div>
                    {!connectedMetamask ? <AddMetamask saveOnAccount /> : <></>}
                </div>
                <Dropdown color='white' options={dropdownOptions}>
                    {(ref, onClick) => (
                        <button
                            className={'flex-grow-0 text-white mt-2'}
                            onClick={onClick}
                            ref={ref}>
                            <ChevronDown />
                        </button>
                    )}
                </Dropdown>
            </div>
        </div>
    )
}
